export const CashManagementCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sportello',
    path: '/sportello',
  },
  {
    name: 'Gestione cassa',
    path: '/sportello/gestione-cassa',
  },
];
